import ReactRenderDatePickerBlock from '../Blocks/DatePicker';
import ReactRenderDropdownBlock from '../Blocks/Dropdown';
import { ContactUsFormFieldEnum, ContactUsConditionalValue } from '../enum/contactUsFormFieldEnum';

class CustomHsForm {
	private listNameOfShowFields: string[] = [];
	constructor() {
		this.init();
	}

	disableSubmitButton = ( form: HTMLFormElement ) => {
		let requiredFields = Array.from( form.querySelectorAll( 'input[required]' ) ) as HTMLInputElement[];
		if ( requiredFields?.length ) {
			const submitButton = form.querySelector( 'input[type="submit"]' ) as HTMLInputElement;
			const buttonWrapper = submitButton.closest( '.actions' ) as HTMLElement;
			buttonWrapper.classList.add( 'disabled' );
			submitButton.disabled = true;
		}
	};

	getFormData = ( form: HTMLFormElement ): { [ key: string ]: string } => {
		const formData = new FormData( form );
		const formValues: { [ key: string ]: string } = {};

		formData.forEach( ( value, key ) => {
			formValues[ key ] = value.toString();
		} );
		return formValues;
	};

	handleShowHideField = ( form: HTMLFormElement, showField: string[] ): void => {
		if ( ! form || ! showField.length ) return;
		const allFields = Array.from( form.querySelectorAll( 'input, select, textarea' ) ) as Array<
			HTMLInputElement | HTMLTextAreaElement
		>;
		const allFieldFormatted = allFields.filter(
			item =>
				item.name !== ContactUsFormFieldEnum.WHICH_ARE_YOU_LOOKING_AT_IN_PARTICULAR &&
				item.name !== ContactUsFormFieldEnum.WHICH_TOOLKIT_WOULD_YOU_LIKE_TO_RECEIVE &&
				item.name !== ContactUsFormFieldEnum.BUSINESS_SECTOR &&
				item.name !== ContactUsFormFieldEnum.COUNTRY_OF_OPERATION
		);
		allFieldFormatted.forEach( field => {
			if ( ! showField.includes( field.name ) ) {
				field.closest( 'fieldset' )?.classList.add( '!hidden' );
			} else {
				field.closest( 'fieldset' )?.classList.remove( '!hidden' );
			}
		} );
	};

	handleToggleRelativeDropdown = ( form: HTMLFormElement, isRelative = false ): void => {
		const howCanWeHelpSelects = Array.from(
			form.querySelectorAll( 'select[name^="ct_us_frm_hch_help_"]' ),
		) as HTMLSelectElement[];
		if ( howCanWeHelpSelects.length ) {
			howCanWeHelpSelects.forEach( select => {
				const parentEle = select.closest( '.input' ) as HTMLElement;
				const customDropdown = parentEle?.querySelector( '.dropdown-content' ) as HTMLElement;
				if ( isRelative ) {
					customDropdown?.classList?.add( '!relative' );
				} else {
					customDropdown?.classList?.remove( '!relative' );
				}
			} );
		}
	};

	handleShowStep2 = ( form: HTMLFormElement ): void => {
		const formData = this.getFormData( form );
		let howCanWeHelpName = '';
		this.listNameOfShowFields = [];
		if ( formData[ ContactUsFormFieldEnum.WHAT_BEST_DESCRIBES_YOU ] ) {
			this.handleToggleRelativeDropdown( form, true );
			switch ( formData[ ContactUsFormFieldEnum.WHAT_BEST_DESCRIBES_YOU ] ) {
				case 'partner':
					howCanWeHelpName = ContactUsFormFieldEnum.HOW_CAN_WE_HELP_PARTNER;
					break;
				case 'social_enterprise':
					howCanWeHelpName = ContactUsFormFieldEnum.HOW_CAN_WE_HELP_SE;
					break;
				case 'supporter':
					howCanWeHelpName = ContactUsFormFieldEnum.HOW_CAN_WE_HELP_SUPPORT;
					break;
				default:
					howCanWeHelpName = '';
					break;
			}
		}

		const labelOfStep = Array.from( form.querySelectorAll( '.form-columns-0' ) ) as HTMLElement[];
		labelOfStep?.[ 0 ]?.classList?.add( '!block' );

		this.listNameOfShowFields = [ ContactUsFormFieldEnum.WHAT_BEST_DESCRIBES_YOU, howCanWeHelpName ].filter(
			Boolean,
		);
		this.handleShowHideField( form, this.listNameOfShowFields );
	};

	toggleShowHideLabelAndButton = ( form: HTMLFormElement, isShow: boolean = true ) => {
		const submitButton = form.querySelector( '.hs_submit' ) as HTMLInputElement;
		const labelOfStep = Array.from( form.querySelectorAll( '.form-columns-0' ) ) as HTMLElement[];
		if (isShow) {
			labelOfStep?.[ 1 ]?.classList?.add( '!block' );
			submitButton && submitButton.classList.remove( 'hidden' );
		} else {
			labelOfStep?.[ 1 ]?.classList?.remove( '!block' );
			submitButton && submitButton.classList.add( 'hidden' );
		}
		
	};

	handleShowStep3 = ( form: HTMLFormElement ): void => {
		const formData = this.getFormData( form );

		if (
			formData[ ContactUsFormFieldEnum.HOW_CAN_WE_HELP_PARTNER ] ||
			formData[ ContactUsFormFieldEnum.HOW_CAN_WE_HELP_SE ] ||
			formData[ ContactUsFormFieldEnum.HOW_CAN_WE_HELP_SUPPORT ]
		) {
			this.handleToggleRelativeDropdown( form );
			this.listNameOfShowFields = [
				...this.listNameOfShowFields,
				ContactUsFormFieldEnum.SALUTATION,
				ContactUsFormFieldEnum.FIRST_NAME,
				ContactUsFormFieldEnum.LAST_NAME,
				ContactUsFormFieldEnum.COMPANY_NAME,
				ContactUsFormFieldEnum.DESIGNATION,
				ContactUsFormFieldEnum.PHONE_NUMBER,
				ContactUsFormFieldEnum.EMAIL,
				ContactUsFormFieldEnum.YOUR_ENQUIRY,
				ContactUsFormFieldEnum.SIGN_ME_UP,
				ContactUsFormFieldEnum.AGREE_POLICY,
			];

			if ( formData[ ContactUsFormFieldEnum.HOW_CAN_WE_HELP_SE ] === ContactUsConditionalValue.REQUEST_TOOLKIT ) {
				this.listNameOfShowFields = [
					...this.listNameOfShowFields.filter( item => item !== ContactUsFormFieldEnum.YOUR_ENQUIRY ),
					ContactUsFormFieldEnum.ORGANIZATION_TYPE,
					ContactUsFormFieldEnum.BUSINESS_WEBSITE,
					ContactUsFormFieldEnum.WHERE_IS_YOUR_BUSINESS_ON_ITS_SOCIAL_IMPACT_JOURNEY,
					ContactUsFormFieldEnum.WHERE_DID_YOU_FIRST_HEAR_ABOUT_RAISE,
				];
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.BUSINESS_SECTOR,
					true,
				);
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.COUNTRY_OF_OPERATION,
					false,
				);
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.WHICH_TOOLKIT_WOULD_YOU_LIKE_TO_RECEIVE,
					false,
				);
				this.toggleFieldVisibility( form, ContactUsFormFieldEnum.WHICH_ARE_YOU_LOOKING_AT_IN_PARTICULAR, true );
			} else if (
				formData[ ContactUsFormFieldEnum.HOW_CAN_WE_HELP_SE ] ===
				ContactUsConditionalValue.LEARN_ABOUT_PROGRAMME_FUND
			) {
				this.listNameOfShowFields = [ ...this.listNameOfShowFields, ContactUsFormFieldEnum.BUSINESS_WEBSITE ];
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.WHICH_ARE_YOU_LOOKING_AT_IN_PARTICULAR,
					false,
				);
				this.toggleFieldVisibility( form, ContactUsFormFieldEnum.BUSINESS_SECTOR, false );
				this.toggleFieldVisibility( form, ContactUsFormFieldEnum.COUNTRY_OF_OPERATION, true );
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.WHICH_TOOLKIT_WOULD_YOU_LIKE_TO_RECEIVE,
					true,
				);
			} else {
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.WHICH_TOOLKIT_WOULD_YOU_LIKE_TO_RECEIVE,
					true,
				);
				this.toggleFieldVisibility(
					form,
					ContactUsFormFieldEnum.WHICH_ARE_YOU_LOOKING_AT_IN_PARTICULAR,
					true,
				);
				this.toggleFieldVisibility( form, ContactUsFormFieldEnum.BUSINESS_SECTOR, true );
			}
			if ( formData[ ContactUsFormFieldEnum.DESIGNATION ]?.includes( 'Others' ) ) {
				this.listNameOfShowFields = [ ...this.listNameOfShowFields, ContactUsFormFieldEnum.OTHER_DESIGNATION ];
			}
			this.handleShowHideField( form, this.listNameOfShowFields );
			this.toggleShowHideLabelAndButton(form);
			// show huspot recaptcha
			const hubspotRecaptcha = form.querySelector( '.hs_recaptcha' ) as HTMLElement;
			if ( hubspotRecaptcha ) {
				hubspotRecaptcha.style.display = 'block';
			}
		}
	};

	toggleFieldVisibility = ( form: HTMLFormElement, fieldName: string, hide: boolean ): void => {
		const field = form.querySelector( `select[name="${ fieldName }"]` ) as HTMLSelectElement;
		if ( field ) {
			const action = hide ? 'add' : 'remove';
			field.closest( '.hs-form-field' )?.classList[ action ]( 'hidden' );
		}
		
		if (hide) {
			field.value = '';
		} 
	};

	validateForm = ( form: HTMLFormElement ): void => {
		const submitButton = form.querySelector( 'input[type="submit"]' ) as HTMLInputElement;
		const buttonWrapper = submitButton.closest( '.actions' ) as HTMLElement;

		const requiredFields = Array.from(form.querySelectorAll( 'input[required], .inputs-list[required] input' )) as HTMLInputElement[];
		const invalidRequiredFields = requiredFields.filter( field => {
			if ( field.type === 'checkbox' || field.type === 'radio' ) {
				return ! field.checked;
			}
			return ! field.value;
		} );

		// Disable or enable the submit button based on validation
		const shouldDisableSubmit = invalidRequiredFields.length > 0;
		buttonWrapper.classList.toggle( 'disabled', shouldDisableSubmit );
		submitButton.disabled = shouldDisableSubmit;

		// Handle showing/hiding fields based on user selections
		if ( form.classList.contains( 'raise-contact-form' ) ) {
			this.handleShowStep2( form );
			this.handleShowStep3( form );
		}
	};

	replaceErrorMessage = ( form: HTMLFormElement ) => {
		const requiredFields = Array.from( form.querySelectorAll( 'input[required]' ) ) as HTMLInputElement[];
		if ( requiredFields?.length ) {
			requiredFields.forEach( item => {
				const parentEle = item.closest( '.hs-form-field' ) as HTMLElement;
				const observer = new MutationObserver( () => {
					const label = parentEle?.querySelector( 'label span' )?.textContent;
					const message = `Please enter a valid ${ label?.toLowerCase() }`;
					const hsError = parentEle?.querySelector( '.hs-error-msgs label' ) as HTMLElement;
					if ( hsError ) {
						hsError.innerHTML = message;
					}
				} );
				observer.observe( parentEle, { attributes: true, childList: true, subtree: false } );
			} );
		}
	};
	customSelectField = ( SelectFields: Array< HTMLElement > ) => {
		if ( SelectFields?.length > 0 ) {
			SelectFields.forEach( ( item: HTMLElement ) => {
				ReactRenderDropdownBlock( item );
				this.handleOpenDropdown( item );
			} );
		}
	};

	preventInputTextPhoneField = ( hsForm: HTMLFormElement ) => {
		if ( ! hsForm ) {
			return;
		}
		const phoneFields = Array.from( hsForm.querySelectorAll( 'input[type="tel"]' ) ) as HTMLInputElement[];
		if ( phoneFields?.length ) {
			phoneFields.forEach( item => {
				item.addEventListener( 'input', function () {
					const countryCode = item?.value?.split( ' ' )?.[ 0 ];
					const currentValue = item?.value?.split( ' ' )?.[ 1 ];
					const prefix = countryCode ? countryCode + ' ' : '';
					const numbersOnly = currentValue ? currentValue?.replace( /[^\d]/g, '' ) : '';
					item.value = prefix + numbersOnly;
				} );
			} );
		}
	};

	handleOpenDropdown = ( dropdown: HTMLElement ) => {
		const dropdownEle = dropdown.querySelector( '.dropdown div' ) as HTMLElement;
		if ( dropdownEle ) {
			dropdownEle.addEventListener( 'click', () => {
				const optionWrapper = dropdown.querySelector( '.dropdown ul' ) as HTMLElement;
				optionWrapper && optionWrapper.classList.toggle( 'active' );
				dropdownEle.classList.toggle( 'open' );
			} );
		}
	};

	customDatePickerField = ( datePickers: Array< HTMLElement > ) => {
		if ( datePickers?.length > 0 ) {
			datePickers.forEach( ( item: HTMLElement ) => {
				ReactRenderDatePickerBlock( item );
			} );
		}
	};

	focusinHSInput = ( inputField: HTMLInputElement | HTMLTextAreaElement ) => {
		if ( ! inputField ) {
			return;
		}
		inputField?.closest( '.hs-form-field' )?.classList.add( 'active' );
	};
	focusoutHSInput = ( inputField: HTMLInputElement | HTMLTextAreaElement ) => {
		if ( ! inputField ) {
			return;
		}
		if ( ! inputField.value ) {
			inputField?.closest( '.hs-form-field' )?.classList.remove( 'active' );
		} else {
			inputField?.closest( '.hs-form-field' )?.classList.add( 'active' );
		}
	};

	handleAddCustomFieldFromDls = ( hsForm: HTMLFormElement ) => {
		if ( ! hsForm ) {
			return;
		}
		const selectFields = Array.from(
			hsForm.querySelectorAll( '.hs-fieldtype-select .input' ),
		) as Array< HTMLElement >;
		const datePickers = Array.from(
			hsForm.querySelectorAll( '.hs-fieldtype-date .input' ),
		) as Array< HTMLElement >;

		const inputFields = Array.from(
			hsForm.querySelectorAll( '.hs-fieldtype-text .input input, textarea' ),
		) as Array< HTMLInputElement | HTMLTextAreaElement >;
		this.disableSubmitButton( hsForm );
		this.customSelectField( selectFields );
		this.customDatePickerField( datePickers );
		this.preventInputTextPhoneField( hsForm );
		this.replaceErrorMessage( hsForm );
		hsForm.addEventListener( 'change', () => this.validateForm( hsForm ) );
		if ( inputFields?.length ) {
			inputFields.forEach( ( item: HTMLInputElement | HTMLTextAreaElement ) => {
				item.addEventListener( 'focusin', () => this.focusinHSInput( item ) );
				item.addEventListener( 'focusout', () => this.focusoutHSInput( item ) );
			} );
		}
	};

	observeIframeForForm( iframe: HTMLIFrameElement ) {
		const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
		if ( ! iframeDocument ) return;

		const observer = new MutationObserver( () => {
			const hsForm = iframeDocument.body.querySelector( '.hs-custom-style' ) as HTMLFormElement | null;
			if ( hsForm ) {
				observer.disconnect();
				this.applyCustomStylesToIframe( iframe, hsForm );
			}
		} );

		observer.observe( iframeDocument.body, {
			childList: true,
			subtree: true,
		} );
	}

	initFormField = ( hsForm: HTMLFormElement ) => {
		const allFields = Array.from( hsForm.querySelectorAll( 'input, select, textarea' ) ) as Array<
			HTMLInputElement | HTMLTextAreaElement
		>;
		const submitButton = hsForm.querySelector( '.hs_submit' ) as HTMLInputElement;
		if ( allFields?.length ) {
			allFields.forEach( field => {
				if ( field.name !== ContactUsFormFieldEnum.WHAT_BEST_DESCRIBES_YOU ) {
					field.closest( 'fieldset' )?.classList.add( '!hidden' );
				}
				if (
					field.name === ContactUsFormFieldEnum.WHICH_TOOLKIT_WOULD_YOU_LIKE_TO_RECEIVE ||
					field.name === ContactUsFormFieldEnum.WHICH_ARE_YOU_LOOKING_AT_IN_PARTICULAR
				) {
					field.closest( '.hs-form-field' )?.classList.add( 'hidden' );
				}
			} );
		}
		if ( submitButton ) {
			submitButton.classList.add( 'hidden' );
		}
	};

	applyCustomStylesToIframe( iframe: HTMLIFrameElement, hsForm: HTMLFormElement ) {
		const raiseForm = iframe.closest( '.raise-form' ) as HTMLElement | null;
		const customFormClass = raiseForm?.dataset.variant ? `raise-${ raiseForm.dataset.variant }-form` : '';

		this.injectCustomCSS( iframe.contentDocument, () => {
			hsForm.classList.add( customFormClass );
			this.handleAddCustomFieldFromDls( hsForm );
			iframe.style.display = 'block';
			if ( hsForm.classList.contains( 'raise-contact-form' ) ) {
				this.initFormField( hsForm );
			}
		} );
	}

	injectCustomCSS( iframeDocument: Document, callback: () => void ) {
		if ( ! window.linkFormCss ) return;

		const linkTag = document.createElement( 'link' );
		linkTag.rel = 'stylesheet';
		linkTag.type = 'text/css';
		linkTag.href = window.linkFormCss;
		linkTag.onload = callback;

		if ( ! iframeDocument.head.querySelector( `link[href="${ window.linkFormCss }"]` ) ) {
			iframeDocument.head.appendChild( linkTag );
		} else {
			callback();
		}
	}

	customStyleHSForm() {
		const observer = new MutationObserver( () => {
			const iframes = Array.from( document.querySelectorAll( '.hs-form-iframe' ) ) as HTMLIFrameElement[];
			if ( ! iframes.length ) return;

			iframes.forEach( iframe => {
				if ( ! iframe.dataset.observed ) {
					iframe.dataset.observed = 'true';
					iframe.style.display = 'none';
					this.observeIframeForForm( iframe );
				}
			} );
		} );

		observer.observe( document.body, { childList: true, subtree: true } );
	}

	init() {
		this.customStyleHSForm();
	}
}

export default CustomHsForm;
